/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *
 *******************************************************************************/

 import React from 'react'
 import { connect } from 'react-redux'
 import PropTypes from 'prop-types'
 import { withStyles } from '@mui/styles'
 import Home from '../../../components/Views/public/Home'
import CompanyServices from '../../../components/Views/public/companyServices'
 
 const styles = theme => ({
   paper: {
       background: 'rgba(0, 0, 0, 0.5)',
   },
 })
 
 class ServicesPage extends React.Component {
   componentDidMount() {
     window.scrollTo(0, 0);
 
   }
   render() {
     return (
       <>
       <CompanyServices />
       </>
     )
   }
 }
 
 ServicesPage.propTypes = {
   classes: PropTypes.object.isRequired,
 }
 
 function mapStateToProps() {
   return {}
 }
 
 const styledServicesPage = withStyles(styles)(ServicesPage)
 const connectedServicesPage = connect(mapStateToProps)(styledServicesPage)
 export { connectedServicesPage as ServicesPage }
 